var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pdf",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.876,
    height: 27.188,
    viewBox: "0 0 20.876 27.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M21.3,0H7.21C6.818,0,6.5.318,6.5.935V26.7a.731.731,0,0,0,.71.485H26.666a.731.731,0,0,0,.71-.485V6.3c0-.338-.045-.447-.125-.527L21.6.125A.429.429,0,0,0,21.3,0Z",
    transform: "translate(-6.5 0)",
    fill: "#e1e6eb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M37.5.151V5.9h5.753Z",
    transform: "translate(-22.45 -0.078)",
    fill: "#9a9a9a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M26.666,47.253H7.21a.71.71,0,0,1-.71-.71V39H27.376v7.543A.71.71,0,0,1,26.666,47.253Z",
    transform: "translate(-6.5 -20.066)",
    fill: "#d2261c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(4.488 20.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M16.541,47.816h-.8V42.924h1.407a1.975,1.975,0,0,1,.617.1,1.678,1.678,0,0,1,.548.3,1.559,1.559,0,0,1,.392.481,1.333,1.333,0,0,1,.15.634,1.734,1.734,0,0,1-.126.674,1.408,1.408,0,0,1-.352.508,1.586,1.586,0,0,1-.544.318,2.094,2.094,0,0,1-.7.113H16.54v1.766Zm0-4.288v1.938h.73a.867.867,0,0,0,.289-.05.728.728,0,0,0,.262-.163.8.8,0,0,0,.192-.315,1.493,1.493,0,0,0,.073-.5,1.355,1.355,0,0,0-.033-.275.8.8,0,0,0-.136-.3.8.8,0,0,0-.289-.239,1.073,1.073,0,0,0-.491-.1h-.6Z",
    transform: "translate(-15.744 -42.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M28.034,45.234a3.594,3.594,0,0,1-.13,1.032,2.566,2.566,0,0,1-.329.717,1.688,1.688,0,0,1-.448.455,2.247,2.247,0,0,1-.481.249,1.989,1.989,0,0,1-.425.106,2.83,2.83,0,0,1-.285.022H24.084V42.924h1.473a2.8,2.8,0,0,1,1.085.2,2.253,2.253,0,0,1,.777.521,2.138,2.138,0,0,1,.461.74A2.45,2.45,0,0,1,28.034,45.234Zm-2.363,2a1.319,1.319,0,0,0,1.168-.518,2.627,2.627,0,0,0,.358-1.5,2.541,2.541,0,0,0-.073-.6,1.292,1.292,0,0,0-.282-.541,1.489,1.489,0,0,0-.568-.392,2.444,2.444,0,0,0-.929-.15h-.465v3.7h.79Z",
    transform: "translate(-20.035 -42.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M35.408,43.528v1.54h2.044v.544H35.408v2.2H34.6V42.924h3.06v.6Z",
    transform: "translate(-25.444 -42.924)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.0012a41d70bb3705c0954a843872292d.svg";
export { ForwardRef as ReactComponent };